"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VenusMagnetizer = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var constants_1 = require("../../constants");
var CardName_1 = require("../../CardName");
var PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var AphroditeRebalanced_1 = require("../rebalanced/rebalanced_corporation/AphroditeRebalanced");
var VenusMagnetizer = (function (_super) {
    __extends(VenusMagnetizer, _super);
    function VenusMagnetizer() {
        return _super.call(this, {
            name: CardName_1.CardName.VENUS_MAGNETIZER,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.VENUS],
            cost: 7,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.venus(10); }),
            metadata: {
                cardNumber: '256',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Decrease your Energy production 1 step to raise Venus 1 step.', function (eb) {
                        eb.production(function (pb) { return pb.energy(1); }).startAction.venus(1);
                    });
                }),
                description: 'Requires Venus 10%.',
            },
        }) || this;
    }
    ;
    VenusMagnetizer.prototype.play = function () {
        return undefined;
    };
    VenusMagnetizer.prototype.canAct = function (player) {
        var venusMaxed = player.game.getVenusScaleLevel() === constants_1.MAX_VENUS_SCALE;
        var hasEnergyProduction = player.getProduction(Resources_1.Resources.ENERGY) > 0;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player.game, PartyName_1.PartyName.REDS)) {
            var adjustedCost = constants_1.REDS_RULING_POLICY_COST - AphroditeRebalanced_1.AphroditeRebalanced.rebalancedAphroditeBonus(player, 1);
            return player.canAfford(adjustedCost) && hasEnergyProduction && !venusMaxed;
        }
        return hasEnergyProduction && !venusMaxed;
    };
    VenusMagnetizer.prototype.action = function (player) {
        player.addProduction(Resources_1.Resources.ENERGY, -1);
        player.game.increaseVenusScaleLevel(player, 1);
        return undefined;
    };
    return VenusMagnetizer;
}(Card_1.Card));
exports.VenusMagnetizer = VenusMagnetizer;
//# sourceMappingURL=VenusMagnetizer.js.map